import { Button, Plus } from "@repo/ui";
import type { BrandPath } from "~/types/api";
import { BrandPathInput, type InputMode } from "./brand-path-input/brand-path-input";
import type { EditBrandPath } from "../brand/brand-paths";

type Props = {
  brandPaths: BrandPath[] | EditBrandPath[];
  addBrandPath: () => void;
  updateBrandPath: (index: number, newProps: Partial<BrandPath>) => void;
  removeBrandPath: (index: number, isNew: boolean) => void;
  mode?: InputMode;
  brandId?: number;
};

export const BrandPathsControl = ({
  brandPaths,
  addBrandPath,
  updateBrandPath,
  removeBrandPath,
  mode = "create",
  brandId = undefined,
}: Props) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <span className="font-bold">Folders</span>
        <Button onClick={addBrandPath} icon={<Plus />} iconPosition="right">
          Add new
        </Button>
      </div>
      <div className="flex flex-col gap-4">
        {brandPaths.length ? (
          (brandPaths as EditBrandPath[]).map(({ includeSubFolders, path, isNew }, index) => (
            <BrandPathInput
              isNew={isNew}
              key={index}
              index={index}
              brandId={brandId}
              mode={mode}
              path={path}
              includeSubFolders={includeSubFolders}
              onChangePath={(path) => updateBrandPath(index, { path })}
              onChangeIncludeSubFolders={(includeSubFolders) =>
                updateBrandPath(index, { includeSubFolders })
              }
              onClickCancel={() => removeBrandPath(index, isNew || false)}
            />
          ))
        ) : (
          <div className="card-border py-7">
            <p className="text-center text-gray-600">No folders added yet</p>
          </div>
        )}
      </div>
    </div>
  );
};
